export default __webpack_public_path__ + "static/media/noa-12.463d941a.jpg";